import { render, staticRenderFns } from "./scholarshipsImport.vue?vue&type=template&id=acf487b6"
import script from "./scholarshipsImport.vue?vue&type=script&lang=js"
export * from "./scholarshipsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports